import { useEffect, useRef } from 'react';

const answers = [
  {
    icon: 'ri-store-2-line',
    question: 'What furniture does Eclectic Home offer?',
    answer:
      'Eclectic Home is a premium furniture store near you in Las Vegas, NV offering 500+ curated pieces across living room, bedroom, dining room, home office, and outdoor collections. Every piece is handpicked for quality, design, and durability — from artisan sofas and bed frames to dining tables and accent decor.',
  },
  {
    icon: 'ri-user-heart-line',
    question: 'Who is this furniture best for?',
    answer:
      'Our modern furniture collections are ideal for homeowners, interior designers, and anyone who values craftsmanship and intentional design. Whether you\'re furnishing a first home, upgrading a single room, or doing a full-home redesign, Eclectic Home has pieces that fit your vision and lifestyle.',
  },
  {
    icon: 'ri-medal-line',
    question: 'What makes Eclectic Home furniture high quality?',
    answer:
      'We source only from manufacturers that share our standards: solid wood frames, premium upholstery fabrics (rated 100,000+ rubs), hand-finished surfaces, and honest construction. We reject mass-market shortcuts. Every high-quality home furniture piece in our showroom has been evaluated in person by our buying team.',
  },
  {
    icon: 'ri-home-4-line',
    question: 'How do you choose the right furniture for your home?',
    answer:
      'Start with your room\'s dimensions, natural light, and how you use the space. Choose a hero piece first — a sofa, bed, or dining table — then build around it. Our free design consultation helps you visualize layouts, mix materials, and create a home that feels cohesive, personal, and beautiful.',
  },
];

export default function AIAnswerBlocks() {
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const o = new IntersectionObserver(([e]) => {
      if (e.isIntersecting) ref.current?.classList.add('visible');
    }, { threshold: 0.1 });
    if (ref.current) o.observe(ref.current);
    return () => o.disconnect();
  }, []);

  return (
    <section className="py-24 bg-cream-mid" itemScope itemType="https://schema.org/WebPage">
      <div ref={ref} className="fade-up max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-14">
          <div className="flex items-center justify-center gap-3 mb-5">
            <span className="w-8 h-px bg-gold" />
            <span className="text-gold text-xs font-bold uppercase tracking-[0.25em]">Everything You Need to Know</span>
            <span className="w-8 h-px bg-gold" />
          </div>
          <h2 className="font-serif text-4xl md:text-5xl font-bold text-dark">
            Questions Answered
          </h2>
        </div>

        {/* Answer Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-5">
          {answers.map((item, i) => (
            <div
              key={item.question}
              className="bg-white rounded-2xl p-8 border border-cream-dark hover:border-gold/30 transition-all group"
              style={{ marginTop: i === 1 ? '20px' : i === 3 ? '20px' : '0' }}
            >
              <div className="flex items-start gap-5">
                <div className="w-12 h-12 flex items-center justify-center rounded-xl bg-gold/8 group-hover:bg-gold/15 transition-colors flex-shrink-0">
                  <i className={`${item.icon} text-gold text-xl`} />
                </div>
                <div>
                  <h3 className="font-semibold text-dark text-sm mb-3 leading-snug">{item.question}</h3>
                  <p className="text-dark/55 text-sm leading-relaxed">{item.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
